import React, {useEffect, useState} from "react";
import {useFormik} from "formik";
import * as yup from "yup";
import {axios_tenant} from "../../../axios";
import PropTypes from "prop-types";

const FilterDialogue = (props) => {
	const [countries, setCountries] = useState([]);
	const [clientNames, setClientNames] = useState([]);
	const [fieldActivities, setFieldActivities] = useState([]);

	useEffect(() => {
		initializeFilter();
		getData();
	}, []);

	const initializeFilter = () => {
		formik.setValues({
			...formik.values,
			...props.customFilters,
		});
	};

	const getData = async () => {
        let response = await axios_tenant.get("/drm/auditResult/dropdown").then((res) => res.data);
		if (response?.success) {
			setCountries(response.data.dropDownResultCountry);
			setClientNames(response.data.dropDownResultClientName);
			setFieldActivities(response.data.dropDownResultFieldActivity);
		}
	};

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			startDate: "",
			endDate: "",
			country: "",
			clientName: "",
			fieldActivityName: "",
		},
		validationSchema: yup.object().shape({
			startDate: yup.string().optional().label("Batch Date (From)"),
			endDate: yup.string().optional().label("Batch Date (To)"),
			country: yup.string().optional().label("Country"),
			clientName: yup.string().optional().label("Client Name"),
			fieldActivityName: yup.string().optional().label("Field/Activity Name"),
		}),
		onSubmit: async (values) => {
			await submit(values);
		},
	});

	const submit = async (values) => {
		props.applyCustomFilter(values);
		props.toggleDialogue();
	};


	return (
		<div className="dialogue">
			<div className="dialogue-content ">
				<div className="dialogue-form">
					<div className="text-end d-flex justify-content-end">
						<i
							className="fa fa-times dialogue-close cursor-pointer"
							role="button"
							tabIndex={0}
							onClick={props.toggleDialogue}
							onKeyDown={(e) => {
							if (e.key === "Enter" || e.key === " ") {
								e.preventDefault();
								props.toggleDialogue();
							}
							}}
							/>
					</div>

					<div className="row mt-3">
						<div className="fw-bold">Batch Date</div>
						<div className="col form-group">
							<label htmlFor="startDate">From</label>
							<input id="startDate" type="date" name="startDate" className="form-control" onChange={formik.handleChange} value={formik.values.startDate} />
						</div>

						<div className="col form-group">
							<label htmlFor="endDate">To</label>
							<input  id="endDate" type="date" name="endDate" className="form-control" onChange={formik.handleChange} value={formik.values.endDate} />
						</div>
					</div>

					<div className="row mt-3">
						<div className="col form-group">
							<label htmlFor="country">Country</label>
							<select id="country" className="form-control" name="country" value={formik.values.country} onChange={formik.handleChange}>
								<option value="">None</option>
								{countries?.length
									? countries.map((item) => (
											<option value={item.country} key={item.country}>
												{item.country}
											</option>
									  ))
									: null}
							</select>
						</div>

						<div className="col form-group">
							<label htmlFor="clientName">Client Name</label>
							<select id="clientName" className="form-control" name="clientName" value={formik.values.clientName} onChange={formik.handleChange}>
								<option value="">None</option>
								{clientNames?.length
									? clientNames.map((item) => (
											<option value={item.client_name} key={item.client_name}>
												{item.client_name}
											</option>
									  ))
									: null}
							</select>
						</div>
					</div>

					<div className="row mt-3">
						<div className="col-6 form-group">
							<label htmlFor="fieldActivityName">Rule Name</label>
							<select id="fieldActivityName" className="form-control" name="fieldActivityName" value={formik.values.fieldActivityName} onChange={formik.handleChange}>
								<option value="">None</option>
								{fieldActivities?.length
									? fieldActivities.map((item) => (
											<option value={item.field_activity_name}  key={item.field_activity_name}>
												{item.field_activity_name}
											</option>
									  ))
									: null}
							</select>
						</div>
					</div>

					<div className="row mt-4">
						<div className="col-6 form-group">
							<button className="btn w-100 default-theme-btn" onClick={formik.handleSubmit}>
								Apply
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

FilterDialogue.propTypes = {
  customFilters: PropTypes.object,
  applyCustomFilter: PropTypes.func.isRequired,
  toggleDialogue: PropTypes.func.isRequired,
};

export default FilterDialogue;